//
//
//
//
//
//
//
//
//
//
//

import HiCell from "../../components/cell/Index.vue";
import HiHeader from "../../components/header/Index.vue";
import HiButton from "../../components/button/Index.vue";

export default {
  name: "PaymentBillingPayPalPage",
  components: { HiCell, HiHeader, HiButton },
};



// WEBPACK FOOTER //
// ./src/pages/payment/BillingPayPal.vue